import { Directive, HostBinding, Input } from '@angular/core';

import { GameType } from '@bpos/v1/sports-promo';
import { AccaBoostConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';

import { AccaBoostToken } from '../../../reward-tokens/reward-tokens.model';
import { AccaBoostError } from '../../model';
import { AccaBoostNotificationService } from '../../services/acca-boost-notification.service';

export interface ViewModel {
    title: string;
    errorMessage: string;
}

@Directive()
export class BaseAccaBoostErroromponent {
    @Input() error: AccaBoostError;
    @Input() token: AccaBoostToken;

    @HostBinding('class') className = 'acca-boost-message acca-boost-message--error';

    protected errorsMap: Record<string, string> = {
        [AccaBoostError.InvalidSport]: this.sitecore.accaBoost.InvalidSportError,
        [AccaBoostError.InvalidCompetition]: this.sitecore.accaBoost.InvalidCompetitionError,
        [AccaBoostError.InvalidMarket]: this.sitecore.accaBoost.InvalidMarketError,
        [AccaBoostError.MinOdds]: this.accaBoostConfig?.isEnhancedLayoutEnabled
            ? this.sitecore.accaBoost.MinOddsHighlightError
            : this.sitecore.accaBoost.MinOddsError,
        [AccaBoostError.InvalidSlipType]: this.sitecore.accaBoost.InvalidSlipTypeError,
        [AccaBoostError.InvalidPickType]: this.sitecore.accaBoost.InvalidPickTypeError,
        [AccaBoostError.Expired]: this.sitecore.accaBoost.AccaBoostExpiredError,
    };

    protected invalidGameTypeErrorsMap: Record<string, string> = {
        [GameType.InPlay]: this.sitecore.accaBoost.OnlyLiveError,
        [GameType.PreMatch]: this.sitecore.accaBoost.OnlyPrematchError,
    };

    constructor(
        protected sitecore: Sitecore,
        protected accaBoostNotificationService: AccaBoostNotificationService,
        protected stringInterpolationPipe: StringInterpolationPipe,
        protected accaBoostConfig?: AccaBoostConfig,
    ) {}
}
